// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // uploadUrl: 'http://localhost:3000/api/upload',
  uploadUrl: './PhotoUpload/api/upload',
  photoUrl: './Photos/',
  apiUrl: './AndonServer/api/',
  // apiError: 'I can not connect to the server.',
  interval: 10000,
  timeDifference: 9
  // Azure Storage
  // sas: '?sv=2017-07-29&si=andon-dev-policy&sr=c&sig=bhjUlXKEd7XD1IirDlSDvuCIuQrsn212b5qXqJrQXO4%3D',
  // storageAccount: 'storage4kispfsol',
  // containerName: 'andon-dev'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
